import { render, staticRenderFns } from "./PixInfractions_Table.vue?vue&type=template&id=48df82cd"
import script from "./PixInfractions_Table.vue?vue&type=script&lang=ts"
export * from "./PixInfractions_Table.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports